/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcceptServiceLevelChangeRequest
 */
export interface AcceptServiceLevelChangeRequest {
    /**
     * 
     * @type {string}
     * @memberof AcceptServiceLevelChangeRequest
     */
    reason: string;
    /**
     * 
     * @type {boolean}
     * @memberof AcceptServiceLevelChangeRequest
     */
    skipEmailNotification: boolean;
}

/**
 * Check if a given object implements the AcceptServiceLevelChangeRequest interface.
 */
export function instanceOfAcceptServiceLevelChangeRequest(value: object): value is AcceptServiceLevelChangeRequest {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('skipEmailNotification' in value) || value['skipEmailNotification'] === undefined) return false;
    return true;
}

export function AcceptServiceLevelChangeRequestFromJSON(json: any): AcceptServiceLevelChangeRequest {
    return AcceptServiceLevelChangeRequestFromJSONTyped(json, false);
}

export function AcceptServiceLevelChangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptServiceLevelChangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
        'skipEmailNotification': json['skipEmailNotification'],
    };
}

export function AcceptServiceLevelChangeRequestToJSON(value?: AcceptServiceLevelChangeRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reason': value['reason'],
        'skipEmailNotification': value['skipEmailNotification'],
    };
}

